
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import MainLayoutSubMenu from './MainLayoutSubMenu.vue'
import { SysMenuOutput as MenuTree } from '@/api/swagger'
import { convertArrayToObject } from '@/util/helpers'
import { useMenuStore } from '@/store/menu'
import { useSettingStore } from '@/store/setting'
import pinia from '@/store'

const menuStore = useMenuStore(pinia)

@Component({
  name: 'MainLayoutMenu',
  components: { MainLayoutSubMenu },
})
export default class MainLayoutMenu extends Vue {
  @Prop({ type: String, default: 'light' })
  private theme!: 'light' | 'dark'

  @Prop({ type: String, default: 'horizontal' })
  private mode!: string

  @Prop({ type: Array, default: null })
  private menus!: MenuTree[]

  private settingStore = useSettingStore()
  private init = false
  private selectedKeys: string[] = []
  private defaultOpenKeys: string[] = []

  private menuToLinksDictionary = {}

  private get menusList() {
    return this.filterMenu(this.menus || menuStore.microMenus)
  }

  public syncSelectedKeys() {
    const find = this.menuToLinksDictionary[this.$route.path]

    if (find) {
      this.selectedKeys = [`menu-item-${find.id}`, `menu-item-${find.pid}`]
    }
  }

  public syncOpenKeys() {
    const find = this.menuToLinksDictionary[this.$route.path]

    if (find) {
      const parent = this.getParent(find)

      if (parent !== undefined) {
        if (this.defaultOpenKeys.length === 0) {
          this.defaultOpenKeys = [`submenu-${parent.id}`]
        }
      }
    }
  }

  private getParent(target: MenuTree, list: MenuTree[] = this.menusList, parent?: MenuTree): MenuTree | void {
    for (const menu of list) {
      if (menu.id === target.id) {
        return parent
      }

      if (menu.children?.length) {
        const result = this.getParent(target, menu.children, menu)

        if (result !== undefined) {
          return result
        }
      }
    }

    return void 0
  }

  @Watch('$route')
  private changeSelected() {
    this.syncSelectedKeys()
  }

  private flat(arr, pid: number | string) {
    return arr.reduce((a, b) => {
      b.pid = pid
      a = a.concat(b)

      if (b.children?.length) {
        a = a.concat(this.flat(b.children, b.id))
      }

      return a
    }, [])
  }

  private filterMenu(menu: MenuTree[]) {
    const data: MenuTree[] = []
    for (const item of menu) {
      if (item.show) {
        data.push(item)
        continue
      }

      if (item.children && item.children.length > 0) {
        item.children = item.children.filter((subItem) => subItem.show)
        this.filterMenu(item.children)
      }
    }
    return data
  }

  protected mounted() {
    const arr = this.flat(menuStore.microMenus, 0)

    this.menuToLinksDictionary = convertArrayToObject({
      arr,
      key: 'link',
      whole: true,
    })

    this.syncSelectedKeys()
    this.syncOpenKeys()

    this.init = true
  }
}
